import {
  QuestionsV3,
  ConstraintTypesV3,
  NumericComparison
} from '../classes/enum';

export interface DynamicFormInputQuestionV3 {
  key: string;
  title: string;
  type: string;
  required: boolean;
  readonly?: boolean;
  displayFormat: string;
  mobiDateFormat: string;
  // TODO: implements conditional questions based on logic options
  logic?: QuestionLogicV3;
  customClasses?: string[];
  order?: number;
  class_id?: string;
  date_format?: string;
  min?: string;
  max?: string;
  color?: string;
  startLabel?: string;
  endLabel?: string;
  dualKnobs?: boolean;
  options?: QuestionOptionV3[];
  display?: boolean;
  displayValue?: boolean;
  useValidatedSlider?: boolean;
  conditionalRules: ConditionnalRules;
  src?: string;
  page: number;
  constraints: QuestionV3Constraint[];
  placeholder: string;
  text?: string;
  repetitions?: Array<any>;
  css?: any;
  condition?: string;
  compulsoryCondition?: string;
  limitCondition?: LimitCondition;
  validators?: Array<any>;
  video?: VideoInfoType;
}

interface LimitCondition {
  condition: string;
  message: string;
}

interface ConditionnalRules {
  isConditionnal: boolean;
  hasMultipleParentQuestions?: boolean;
  parentQuestions?: Array<{
    name: string;
    valuesToBeTruthy: Array<string>;
    hasMultipleValuesToSatisfy: boolean;
    comparisonOperator: NumericComparison;
  }>;
  logicOperator: string;
}

interface QuestionLogicV3 {
  action: string;
  checks: [];
  conditional: string;
}

export interface QuestionOptionV3 {
  value: string;
  key: string;
  color?: string;
  imageSrc?: string;
}

// FormV3 interface

export interface FormV3 {
  abspath?: string;
  uuid: string;
  title: string;
  color: string;
  image: string;
  canEdit: boolean;
  canRepeat: boolean;
  classId: string;
  canChangeActivity: boolean;
  currentPage: number;
  prevPage: number;
  skip: any;
  questionPages: QuestionsV3[][];
  activities: FormV3Activity[];
  selectedActivity: FormV3Activity;
  invalidFields: FormV3InvalidField[];
  currentPageValid?: boolean;
  messagePopupFormFieldError?: string;
  intPageOccurrence?: string;
  deeplinkData?: any; // MYFSHD
}

export interface FormV3Activity {
  uuid: string;
  date: string;
  done: boolean;
  readonly: boolean;
  responses: any;
  lastAuthor: string;
  dataToCheck: string[];
  hideSelector?: boolean;
}

export interface FormV3InvalidField {
  questionKey: string;
  messages?: string[];
  requiredCount?: number;
  maxLenCount?: number;
  limitCount?: number;
  photoSizeLimitCount?: number;
  controlErrors?: any;
}

export interface QuestionV3Constraint {
  type: ConstraintTypesV3;
  max?: number;
  min?: number;
  maxIndicative?: number;
  minIndicative?: number;
  length?: number;
  maxLength?: number;
  minLength?: number;
  value?: number;
  errorMessage: string;
  conditional?: boolean;
  maxSize?: number;
  allowedExtension?: string[];
}

export interface VideoInfoType {
  videoType: string;
  url: string;
}
